var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.032,
    height: 27.032,
    viewBox: "0 0 27.032 27.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-health-insurance-3926084",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11430",
    "data-name": "Path 11430",
    d: "M178.675,17.5H160.654a3.157,3.157,0,0,0-3.154,3.154v3.154a.451.451,0,1,0,.9,0V20.654a2.255,2.255,0,0,1,2.253-2.253h16.231a2.229,2.229,0,0,0-.462,1.352v8.4a.451.451,0,1,0,.9,0V22.906h3.154a.45.45,0,0,0,.451-.451v-2.7a2.255,2.255,0,0,0-2.253-2.253Zm1.352,4.505h-2.7V19.753a1.352,1.352,0,1,1,2.7,0Z",
    transform: "translate(-153.896 -17.5)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11431",
    "data-name": "Path 11431",
    d: "M110.477,182.379a.451.451,0,0,0-.451.451v.541a1.352,1.352,0,1,1-2.7,0v-.9a.451.451,0,0,0-.451-.451H92.005V166.7a.451.451,0,0,0-.9,0v15.318H87.951a.451.451,0,0,0-.451.451v.9a2.255,2.255,0,0,0,2.253,2.253h2.253a.451.451,0,1,0,0-.9H89.753A1.351,1.351,0,0,1,88.4,183.37v-.451h18.021v.451a2.241,2.241,0,0,0,.451,1.352H93.807a.451.451,0,1,0,0,.9h14.867a2.255,2.255,0,0,0,2.253-2.253v-.541a.45.45,0,0,0-.451-.451Z",
    transform: "translate(-87.5 -158.591)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11432",
    "data-name": "Path 11432",
    d: "M429.462,246.8h-.154a5.664,5.664,0,0,1-4.032-1.67.451.451,0,0,0-.637,0,5.664,5.664,0,0,1-4.032,1.67h-.154a.451.451,0,0,0-.451.451V250.5a5.887,5.887,0,0,0,2.844,5.022l1.88,1.126h0a.451.451,0,0,0,.464,0l1.88-1.126h0a5.887,5.887,0,0,0,2.844-5.022.451.451,0,1,0-.9,0,4.98,4.98,0,0,1-2.406,4.249l-1.648.989-1.648-.991A4.981,4.981,0,0,1,420.9,250.5v-2.8h0a6.55,6.55,0,0,0,4.055-1.629,6.551,6.551,0,0,0,4.055,1.629v.907a.451.451,0,1,0,.9,0v-1.352a.45.45,0,0,0-.451-.451Z",
    transform: "translate(-402.881 -233.288)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11433",
    "data-name": "Path 11433",
    d: "M458.337,290.024a.454.454,0,0,0-.5,0,7.4,7.4,0,0,1-2.548,1.059.451.451,0,0,0-.36.441v1.614a4.075,4.075,0,0,0,1.968,3.477l.953.572h0a.45.45,0,0,0,.464,0l.953-.572h0a4.075,4.075,0,0,0,1.971-3.479v-1.614a.451.451,0,0,0-.36-.441,7.393,7.393,0,0,1-2.546-1.057Zm2.005,3.111a3.169,3.169,0,0,1-1.532,2.7l-.721.433-.721-.433a3.169,3.169,0,0,1-1.532-2.7v-1.256a8.271,8.271,0,0,0,2.253-.946,8.271,8.271,0,0,0,2.253.946Z",
    transform: "translate(-436.014 -275.922)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11434",
    "data-name": "Path 11434",
    d: "M486.493,341.932a.451.451,0,0,0-.637.637l.9.9a.451.451,0,0,0,.637,0l1.352-1.352a.451.451,0,0,0-.637-.637l-1.033,1.033Z",
    transform: "translate(-465.225 -324.68)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11435",
    "data-name": "Path 11435",
    d: "M292.8,70H291a.451.451,0,0,0-.451.451V71.8H289.2a.451.451,0,0,0-.451.451v1.8a.45.45,0,0,0,.451.451h1.352v1.352a.451.451,0,0,0,.451.451h1.8a.45.45,0,0,0,.451-.451V74.505h1.352a.451.451,0,0,0,.451-.451v-1.8a.451.451,0,0,0-.451-.451h-1.352V70.451A.45.45,0,0,0,292.8,70Zm1.352,2.7v.9H292.8a.451.451,0,0,0-.451.451v1.352h-.9V74.055A.45.45,0,0,0,291,73.6h-1.352v-.9H291a.451.451,0,0,0,.451-.451V70.9h.9v1.352a.45.45,0,0,0,.451.451Z",
    transform: "translate(-278.388 -67.297)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11436",
    "data-name": "Path 11436",
    d: "M271.25,219.2a.451.451,0,0,0,.451.451h7.208a.451.451,0,1,0,0-.9H271.7A.451.451,0,0,0,271.25,219.2Z",
    transform: "translate(-261.789 -208.388)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11437",
    "data-name": "Path 11437",
    d: "M210,254.2a.45.45,0,0,0,.451.451h9.461a.451.451,0,1,0,0-.9h-9.461A.451.451,0,0,0,210,254.2Z",
    transform: "translate(-203.693 -241.586)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11438",
    "data-name": "Path 11438",
    d: "M210.451,289.651h9.011a.451.451,0,1,0,0-.9h-9.011a.451.451,0,1,0,0,.9Z",
    transform: "translate(-203.693 -274.784)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11439",
    "data-name": "Path 11439",
    d: "M210.451,324.651h9.011a.451.451,0,1,0,0-.9h-9.011a.451.451,0,1,0,0,.9Z",
    transform: "translate(-203.693 -307.982)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11440",
    "data-name": "Path 11440",
    d: "M210.451,359.651h5.406a.451.451,0,0,0,0-.9h-5.406a.451.451,0,1,0,0,.9Z",
    transform: "translate(-203.693 -341.18)",
    fill: "#e2c195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11441",
    "data-name": "Path 11441",
    d: "M285.522,393.737l-1.835,1.1-.031-.061h0a.85.85,0,0,0-1.232-.327l-.552.368a.85.85,0,0,0-1.335-.17l-.509.509a.451.451,0,1,0,.637.637l.461-.461h0a.851.851,0,0,0,1.2.266l.55-.367.029.059h0a.85.85,0,0,0,1.2.348l1.883-1.13h0a.451.451,0,1,0-.464-.772Z",
    transform: "translate(-269.986 -374.3)",
    fill: "#e2c195"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.4b7bb9c04c288b0c654add0c61f2d41e.svg";
export { ForwardRef as ReactComponent };